import {
  Accordion,
  Box,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { InvestmentFinancialMetricsDTO } from '@inversor-hub/types';
import { buildQualityNotes } from './metrics-copy';
import { cardSurface } from '../shared/surfaces';

interface DataQualityPanelProps {
  metrics: InvestmentFinancialMetricsDTO;
  canEdit: boolean;
  onReviewClassification: () => void;
}

export const DataQualityPanel = ({
  metrics,
  canEdit,
  onReviewClassification,
}: DataQualityPanelProps) => {
  const unclassified = metrics.quality.unclassifiedLineCount;
  const notes = buildQualityNotes(metrics);

  return (
    <Box component="section">
      {unclassified > 0 && (
        <Alert
          severity="warning"
          sx={{ mb: 2 }}
          action={
            canEdit && (
              <Button size="small" onClick={onReviewClassification} sx={{ whiteSpace: 'nowrap' }}>
                Revisar
              </Button>
            )
          }
        >
          {unclassified === 1
            ? 'Hay 1 movimiento sin clasificar que no entra en estos números.'
            : `Hay ${unclassified} movimientos sin clasificar que no entran en estos números.`}
        </Alert>
      )}

      <Accordion disableGutters elevation={0} sx={cardSurface}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle2" fontWeight={600}>
            De dónde salen estos números
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List dense disablePadding>
            {notes.map((note) => (
              <ListItem key={note} disableGutters sx={{ alignItems: 'flex-start' }}>
                <ListItemText
                  primary={note}
                  primaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                />
              </ListItem>
            ))}
          </List>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
